import $ from 'cash-dom'

const progressBarSection = $('#shopify-section-progress-bar-section')
const sectionBarText = progressBarSection.find('[data-element="progress-text"]')

const decodeAndReplacePlaceholders = (template, placeholders) => {
  // First decode HTML entities
  const decoded = template
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")

  // Then replace all placeholders
  const placeholderRegex =
    /{tier_percentage}|{item_count}|{percentage}|{plural}/g
  return decoded.replace(placeholderRegex, (match) => {
    if (match === '{plural}') {
      return placeholders[match] || ''
    }
    return placeholders[match] || match
  })
}

const updateProgressBar = (data) => {
  if (!Pura.progress_bar?.enable && !Pura.progress_section?.enable) return

  const defaultExcludedTypes = [
    'Sample',
    'Sample Card',
    'Plus Set',
    'Car Pro Set',
    'Plus',
    'Car Pro',
    'Gift',
    'Free Diffuser Set',
  ]

  let excludedProductTypes = defaultExcludedTypes
  if (Pura.progress_bar?.excludedProductTypes) {
    if (typeof Pura.progress_bar.excludedProductTypes === 'string') {
      excludedProductTypes = Pura.progress_bar.excludedProductTypes
        .split(',')
        .map((type) => type.trim())
        .filter((type) => type.length > 0)
    } else if (Array.isArray(Pura.progress_bar.excludedProductTypes)) {
      excludedProductTypes = Pura.progress_bar.excludedProductTypes
    }
  }
  const excludedProductIDs = Pura.cart.evergreen_promo_ids ?? []
  const excludedGroupIDs = []

  if (excludedProductIDs) {
    data.items.forEach((item) => {
      if (excludedProductIDs.includes(item.product_id)) {
        const groupId = item.properties?._pura_group_id
        if (groupId) {
          excludedGroupIDs.push(groupId)
        }
      }
    })
  }

  const cartQuantity = data.items
    .filter(
      (item) =>
        !excludedProductTypes?.includes(item.product_type) &&
        !excludedProductIDs?.includes(item.product_id) &&
        !excludedGroupIDs?.includes(item.properties?._pura_group_id) &&
        item.properties?._pura_gwp_product != true
    )
    .reduce((total, item) => total + item.quantity, 0)

  const maxItems = Pura.progress_bar.maxItems
  const maxDiscount = Pura.progress_bar.maxDiscount
  const minDiscount = Pura.progress_bar.minDiscount
  const excludeFirstFromDiscount =
    Pura.progress_bar.excludeFirstFromDiscount || false

  const progressPercentage = (cartQuantity / maxItems) * 100
  const itemsToNextTier = Math.max(0, maxItems - cartQuantity)

  let currentDiscount
  if (excludeFirstFromDiscount) {
    if (cartQuantity === 0) {
      currentDiscount = 0
    } else if (cartQuantity === 1) {
      currentDiscount = 0
    } else {
      const discountPerItem = maxDiscount / (maxItems - 1)
      currentDiscount = Math.floor((cartQuantity - 1) * discountPerItem)
    }
  } else {
    const discountPerItem = (maxDiscount - minDiscount) / (maxItems - 1)
    currentDiscount =
      Math.floor(cartQuantity * discountPerItem) +
      (minDiscount - discountPerItem)
  }
  const progressSectionEnabled = Pura.progress_section?.enable || false
  const progressCartEnabled = Pura.progress_bar?.enable || false

  const placeholders = {
    '{tier_percentage}': currentDiscount,
    '{item_count}': itemsToNextTier,
    '{percentage}': maxDiscount,
    '{plural}': itemsToNextTier > 1 ? 's' : '',
  }

  const defaultMessage = progressSectionEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_section.default, placeholders)
    : false

  const defaultCartMessage = progressCartEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_bar.default, placeholders)
    : false

  const oneItemMessage = progressSectionEnabled
    ? decodeAndReplacePlaceholders(
        Pura.progress_section.one_item || Pura.progress_section.progress,
        placeholders
      )
    : false
  const oneItemCartMessage = progressCartEnabled
    ? decodeAndReplacePlaceholders(
        Pura.progress_bar.one_item || Pura.progress_bar.progress,
        placeholders
      )
    : false

  const progressMessage = progressSectionEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_section.progress, placeholders)
    : false
  const progressCartMessage = progressCartEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_bar.progress, placeholders)
    : false

  const successMessage = progressSectionEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_section.success, placeholders)
    : false

  const successCartMessage = progressCartEnabled
    ? decodeAndReplacePlaceholders(Pura.progress_bar.success, placeholders)
    : false

  // Update all progress bar components on the page
  const progressBarComponents = $('[data-component="progress-bar"]')

  progressBarComponents.each(function () {
    const $component = $(this)
    const progressBar = $component.find('.bar')
    const progressBarItems = $component.find('.bar-item')
    const progressLabels = $component.find('.label')
    const progressBarText = $component.find('[data-element="progress-text"]')

    progressLabels.each(function (index) {
      const tier = (index + 1) * 20
      $(this).toggle(progressPercentage === tier)
    })

    let message, sectionMessage

    if (cartQuantity >= maxItems) {
      message = successCartMessage
      sectionMessage = successMessage
      progressBar.addClass('rounded-2xl')
    } else if (cartQuantity === 0) {
      message = defaultCartMessage
      sectionMessage = defaultMessage
      progressBar.removeClass('rounded-2xl')
    } else if (cartQuantity === 1 && excludeFirstFromDiscount) {
      message = oneItemCartMessage
      sectionMessage = oneItemMessage
      progressBar.removeClass('rounded-2xl')
    } else {
      message = progressCartMessage
      sectionMessage = progressMessage
      progressBar.removeClass('rounded-2xl')
    }

    if (message) {
      progressBarText.html(message)
    }

    // Update segmented progress bar items
    const filledSegments = Math.min(cartQuantity, maxItems)
    progressBarItems.each(function (index) {
      const segmentNumber = index + 1
      if (segmentNumber <= filledSegments) {
        $(this).removeClass('bg-[#ADC1B4]').addClass('bg-[#336444]')
      } else {
        $(this).removeClass('bg-[#336444]').addClass('bg-[#ADC1B4]')
      }
    })

    // Keep the continuous bar for backwards compatibility if it exists
    if (progressBar.length > 0) {
      progressBar.removeClass('hidden').addClass('block transition-fast')
      progressBar.css('width', `${Math.min(progressPercentage, 100)}%`)
    }
  })

  // Update section bar text separately
  if (sectionBarText.length > 0) {
    let sectionMessage
    if (cartQuantity >= maxItems) {
      sectionMessage = successMessage
    } else if (cartQuantity === 0) {
      sectionMessage = defaultMessage
    } else if (cartQuantity === 1 && excludeFirstFromDiscount) {
      sectionMessage = oneItemMessage
    } else {
      sectionMessage = progressMessage
    }
    if (sectionMessage) {
      sectionBarText.html(sectionMessage)
    }
  }
}

export { updateProgressBar }
